import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  onCreateGraduated,
  onCreateUserForGraduated,
  onDeleteGraduated,
  onGetGraduated,
  onGetGraduatesByUserId,
  onGetPagedAllGraduates,
  onUpdateGraduated,
} from '../../../app/modules/graduation-system/components/graduates/core/_requests'
import {
  onGetDegrees,
  onGetDepartmentsByFacultyId,
  onGetDistrictsByProvinceId,
  onGetFaculties,
  onGetGenders,
  onGetGraduationTypes,
  onGetIndustries,
  onGetJobLevels,
  onGetProgramsWithFaculties,
  onGetProgramTypesByDegreeId,
  onGetProvincesByCountryId,
  onGetScoreTypes,
  onGetSubDepartmentsByDepartmentId,
  onGetUsers,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface GraduatedState {
  graduates: any
  graduated: any
  users: any
  programs: any
  scoreTypes: any
  graduationTypes: any
  provinces: any
  districts: any
  faculties: any
  departments: any
  degrees: any
  programTypes: any
  subDepartments: any
  industries: any
  jobLevels: any
  genders : any
  isLoading: boolean
}
const initialState = {
  graduates: [],
  graduated: null,
  users: [],
  programs: [],
  scoreTypes: [],
  graduationTypes: [],
  provinces: [],
  districts: [],
  faculties: [],
  departments: [],
  subDepartments: [],
  degrees: [],
  programTypes: [],
  industries : [],
  jobLevels: [],
  genders: [],
  isLoading: true,

} as GraduatedState

export const fetchUsers = createAsyncThunk('graduated/fetchUsers', async () => {
  const data: any = await onGetUsers()

  return data.data.result.items
})

export const fetchGraduationTypes = createAsyncThunk('graduated/fetchGraduationTypes', async () => {
  const data: any = await onGetGraduationTypes()

  return data.data.result.items
})

export const fetchPrograms = createAsyncThunk('graduated/fetchPrograms', async () => {
  const data: any = await onGetProgramsWithFaculties()
  return data.data.result
})

export const fetchScoreTypes = createAsyncThunk('graduated/fetchScoreTypes', async () => {
  const data: any = await onGetScoreTypes()
  return data.data.result
})

export const fetchProvinces = createAsyncThunk('graduated/fetchProvinces', async (param: any) => {
  const data: any = await onGetProvincesByCountryId(param)
  return data.data.result
})

export const fetchDistricts = createAsyncThunk('graduated/fetchDistricts', async (param: any) => {
  const data: any = await onGetDistrictsByProvinceId(param)
  return data.data.result
})

export const fetchGraduates = createAsyncThunk('graduated/fetchGraduates', async (param: any) => {
  const data: any = await onGetPagedAllGraduates(param)
  return data.data.result
})

export const fetchGraduatesByUserId = createAsyncThunk(
  'graduated/fetchGraduatesByUserId',
  async (param: any) => {
    const data: any = await onGetGraduatesByUserId(param)
    return data.data.result
  }
)

export const fetchGraduated = createAsyncThunk('graduated/fetchGraduated', async (param: any) => {
  const data: any = await onGetGraduated(param)
  return data.data.result
})

export const updateGraduated = createAsyncThunk('graduated/updateGraduated', async (param: any) => {
  const data: any = await onUpdateGraduated(param)
  return data.data
})

export const createUserForGraduated = createAsyncThunk('graduated/createUserForGraduated', async (param: any) => {
  const data: any = await onCreateUserForGraduated(param)
  return data.data
})

export const createGraduated = createAsyncThunk('graduated/createGraduated', async (param: any) => {
  const data: any = await onCreateGraduated(param)
  return data.data
})

export const deleteGraduated = createAsyncThunk('graduated/deleteGraduated', async (param: any) => {
  const data: any = await onDeleteGraduated(param)
  return data.data
})


export const fetchFaculties = createAsyncThunk('sendEmail/fetchFaculties', async () => {
  const data: any = await onGetFaculties()
  return data.data.result
})

export const fetchDepartments = createAsyncThunk(
  'sendEmail/fetchDepartments',
  async (param: any) => {
    const data: any = await onGetDepartmentsByFacultyId(param)
    return data.data.result
  }
)

export const fetchSubDepartments = createAsyncThunk(
  'sendEmail/fetchSubDepartments',
  async (param: any) => {
    const data: any = await onGetSubDepartmentsByDepartmentId(param)
    return data.data.result
  }
)

export const fetchDegrees = createAsyncThunk('sendEmail/fetchDegrees', async () => {
  const data: any = await onGetDegrees()
  return data.data.result
})

export const fetchProgramTypes = createAsyncThunk(
  'sendEmail/fetchProgramTypes',
  async (param: any) => {
    const data: any = await onGetProgramTypesByDegreeId(param)
    return data.data.result
  }
)
export const fetchIndustries = createAsyncThunk('graduated/fetchIndustries', async () => {
  const data: any = await onGetIndustries()
  return data.data.result
})

export const fetchJobLevels = createAsyncThunk('graduated/fetchJobLevels', async () => {
  const data: any = await onGetJobLevels()
  return data.data.result
})

export const fetchGenders = createAsyncThunk('graduated/fetchGenders', async () => {
  const data: any = await onGetGenders()
  return data.data.result
})

const graduatedSlice = createSlice({
  name: 'graduated',
  initialState,
  reducers: {
    clearGraduates: (state) => {
      state.graduates = []
    },
    clearGraduated: (state) => {
      state.graduated = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
    clearAllFilters: (state) => {
      //state.faculties = []
      state.departments = []
      state.subDepartments = []
      state.programTypes = []
      state.degrees = []
      state.industries = []
      state.jobLevels = []
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchGraduates.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchGraduates.fulfilled, (state: any, action) => {
      state.graduates = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchGraduates.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchGraduatesByUserId.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchGraduatesByUserId.fulfilled, (state: any, action) => {
      state.graduates = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchGraduatesByUserId.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchGraduated.fulfilled, (state: any, action) => {
      state.graduated = action.payload
    })
    builder.addCase(fetchUsers.fulfilled, (state: any, action) => {
      state.users = action.payload
    })
    builder.addCase(fetchGraduationTypes.fulfilled, (state: any, action) => {
      state.graduationTypes = action.payload
    })
    builder.addCase(fetchPrograms.fulfilled, (state: any, action) => {
      state.programs = action.payload.items
    })
    builder.addCase(fetchScoreTypes.fulfilled, (state: any, action) => {
      state.scoreTypes = action.payload.items
    })
    builder.addCase(fetchProvinces.fulfilled, (state: any, action) => {
      state.provinces = action.payload.items
    })
    builder.addCase(fetchDistricts.fulfilled, (state: any, action) => {
      state.districts = action.payload.items
    })
    builder.addCase(fetchGenders.fulfilled, (state: any, action) => {
      state.genders = action.payload.items
    })
    builder.addCase(fetchFaculties.fulfilled, (state: any, action) => {
        state.faculties = action.payload.items
      })
      builder.addCase(fetchDepartments.fulfilled, (state: any, action) => {
        state.departments = action.payload.items
      })
      builder.addCase(fetchSubDepartments.fulfilled, (state: any, action) => {
        state.subDepartments = action.payload.items
      })
      builder.addCase(fetchDegrees.fulfilled, (state: any, action) => {
        state.degrees = action.payload.items
      })
      builder.addCase(fetchProgramTypes.fulfilled, (state: any, action) => {
        state.programTypes = action.payload.items
      })
      builder.addCase(fetchIndustries.fulfilled, (state: any, action) => {
        state.industries = action.payload.items
      })
      builder.addCase(fetchJobLevels.fulfilled, (state: any, action) => {
        state.jobLevels = action.payload.items
      })
  },
})

export const {clearGraduates, clearAllFilters, clearGraduated, activateLoading} = graduatedSlice.actions

export default graduatedSlice.reducer
